import { render } from "./LoaderComponent.vue?vue&type=template&id=295c0ba4&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=295c0ba4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295c0ba4"]])

export default __exports__